import {
  errorMessageForApolloClientGraphqlError,
  errorMessageForNotFound
} from '@common/api/graphql/errorMessage';
import type { GraphQLFormattedError } from 'graphql';
import { requestFailure } from '../actions';
import type { AppThunkAction } from '../thunkType';

export const GRAPHQL_ERROR_NOT_FOUND_CODE = 'NOT_FOUND';
export const INTERNAL_SERVER_ERROR_CODE = 'INTERNAL_SERVER_ERROR';

export const handleGraphqlErrors =
  (
    errors: ReadonlyArray<GraphQLFormattedError>
  ): AppThunkAction<Promise<void>> =>
  dispatch => {
    const firstGraphqlError = errors[0];
    if (firstGraphqlError.extensions?.code === GRAPHQL_ERROR_NOT_FOUND_CODE) {
      dispatch(
        requestFailure(
          errorMessageForNotFound,
          firstGraphqlError.extensions.code
        )
      );
    } else {
      dispatch(
        requestFailure(
          errorMessageForApolloClientGraphqlError,
          INTERNAL_SERVER_ERROR_CODE
        )
      );
    }
    return Promise.reject(JSON.stringify(errors));
  };
